<dx-data-grid
    class="h-100"
    [dataSource]="status"
    [remoteOperations]="false"
    [rowAlternationEnabled]="true"
    [allowColumnResizing]="true"
    noDataText="{{ 'keine Status im Account' | translate }}"
    [showBorders]="true"
    (onSelectionChanged)="onSelectionChanged($event)"
    (onRowRemoving)="deleteStatus($event)"
    (onRowUpdated)="update($event)"
>
  <dxo-toolbar>
    <dxi-item location="before">
      <dx-button
          stylingMode="outlined"
          type="default"
          text="{{ 'Neuer Status' | translate }}"
          (onClick)="addStatus()"
      ></dx-button>
    </dxi-item>
    <dxi-item location="after">
      <dx-button
          stylingMode="outlined"
          type="default"
          text="{{ 'Auswahl löschen' | translate }}"
          (onClick)="deleteMultiple()"
      ></dx-button>
    </dxi-item>
    <dxi-item name="searchPanel" location="after"/>
  </dxo-toolbar>

  <dxo-selection mode="multiple" showCheckBoxesMode="always"/>
  <dxo-editing mode="cell" [allowDeleting]="true" [allowUpdating]="true" [useIcons]="true"/>
  <dxo-scrolling mode="virtual"/>
  <dxo-search-panel [visible]="true" [highlightCaseSensitive]="true" placeholder="{{ 'Status suchen' | translate }}"/>

  <dxi-column dataField="name" caption="{{ 'Name' | translate }}" (onValueChanged)="update($event)"/>
</dx-data-grid>
